import { render, staticRenderFns } from "./QSdetail.vue?vue&type=template&id=9755fdbc&scoped=true&"
import script from "./QSdetail.vue?vue&type=script&lang=js&"
export * from "./QSdetail.vue?vue&type=script&lang=js&"
import style0 from "./QSdetail.vue?vue&type=style&index=0&id=9755fdbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9755fdbc",
  null
  
)

export default component.exports